import { PropsWithChildren } from 'react'
import { motion } from 'motion/react'

export const TapEffect = ({ children }: PropsWithChildren) => (
  <motion.div tabIndex={-1} whileHover={{ scale: 1.1 }} whileTap={{ scale: 0.8 }}>
    {children}
  </motion.div>
)
